import { Tab } from '../../../../../modals/modifier/ModifierModal';

export default {
  title: 'Nuovo modificatore',
  tabs: {
    [Tab.General]: 'Generale',
    [Tab.NutritionInfo]: 'Info nutrizionali',
  },
  form: {
    modifier_groups: {
      label: 'Appartiene a gruppi di modificatori',
    },
    name: {
      label: 'Nome',
      placeholder: 'Ketchup',
    },
    external_id: {
      label: 'Riferimento {{integration}}',
      placeholder: 'es. riferimento SKU HubRise',
      read_only_hint: "Modificabile solo con un'integrazione HubRise attiva e sincronizzazione menu disattivata.",
    },
    price: {
      label: 'Prezzo base',
      placeholder: 'Facoltativo',
    },
    is_available: {
      label: 'Disponibile',
    },
    is_visible: {
      label: 'Visibile',
      title: 'Visibile sul menu',
      subtitle_on: 'I clienti possono vedere questa opzione',
      subtitle_off: 'Nascosto a tutti i clienti',
    },
    is_available_for_pickup: {
      label: 'Disponibile per asporto',
      subtitle_on: 'I clienti possono ordinarlo per asporto',
      subtitle_off: 'Nascosto dal menu asporto',
    },
    is_available_for_delivery: {
      label: 'Disponibile per consegna',
      subtitle_on: 'I clienti possono ordinarlo per consegna',
      subtitle_off: 'Nascosto dal menu consegna',
    },
  },
  availability: {
    title: 'Disponibilità',
    helper:
      "La visibilità è l'interruttore principale. Disattiva un canale per nascondere questa opzione ai clienti asporto o consegna senza rimuoverla dal menu.",
    status: {
      both: 'Entrambi i canali',
      pickup_only: 'Solo asporto',
      delivery_only: 'Solo consegna',
      hidden: 'Nascosto',
      no_channels: 'Nessun canale',
    },
    warning: {
      no_channels:
        'Questa opzione è visibile ma non disponibile su nessun canale — i clienti non potranno selezionarla.',
    },
    placeholder: '—',
    list_badge: {
      pickup_only: 'Solo asporto',
      delivery_only: 'Solo consegna',
      no_channels: 'Nessun canale',
    },
  },
  buttons: {
    save: 'Salva',
  },
  toasts: {
    changes_got_saved: 'Modifiche salvate con successo!',
  },
};
